// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"GroupHeader_subtitle__IjJQ2","header":"GroupHeader_header__vjuLu"};